import { render, staticRenderFns } from "./add-record.vue?vue&type=template&id=25de3d1e"
import script from "./add-record.vue?vue&type=script&lang=js"
export * from "./add-record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports